import Vue from 'vue'
export const JustDigits = () => {
  Vue.directive('digitsonly', (el) => {
    // bind (el) {
      el.addEventListener('keydown', (e) => {
        // delete, backpsace, tab, escape, enter,
        let special = [46, 8, 9, 27, 13, 110, 190]
        // special from above
        if (special.indexOf(e.keyCode) !== -1 ||
          // Ctrl+A
          (e.keyCode === 65 && e.ctrlKey === true) ||
          // Ctrl+C
          (e.keyCode === 67 && e.ctrlKey === true) ||
          // Ctrl+X
          (e.keyCode === 88 && e.ctrlKey === true) ||
          // Ctrl+Z
          (e.keyCode === 90 && e.ctrlKey === true) ||
          // home, end, left, right
          (e.keyCode >= 35 && e.keyCode <= 39)) {
          return
        }
        if (
          ((!e.shiftKey && (e.keyCode >= 48 && e.keyCode <= 57)) ||
          (e.keyCode >= 96 && e.keyCode <= 105))) {
          return
        }
        // otherwise stop the keystroke
        e.preventDefault()
      })
    // }
  })
};
